<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="'库存明细'"></el-page-header>
		<el-form label-position="right" :model="item" label-width="auto">
			<el-form-item label="商品名称" prop="goodsImage">
			</el-form-item>
			<div>
				<!-- <p style="margin:22px 0 10px 0">价格</p> -->
				<el-table style="margin-bottom: 22px; margin-top:0;" ref="multipleTable" :data="item" border
					tooltip-effect="dark">
					<el-table-column label="商品规格" prop="sku_name" align="center">

					</el-table-column>
					<el-table-column label="当前库存（件）">
						<template slot-scope="scope">
							<el-input :value = "scope.row.stock" disabled></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				id: this.$route.query.id,
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			loadData: async function() {
				// 获取商品信息
				await this.axios.post('/admin/stock/detail', {
					id: this.id
				}).then(res => {
					this.item = res.data.sku

				})
			},
			// 后退一步
			goBack() {
				window.close()
				// this.$router.back(-1)
			}
		}
	}
</script>
<style scoped>
	.goods-spec {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.goods-spec .goods-spec-add {
		margin-left: 30px;
		margin-bottom: 14px;
	}

	.goods-container .button-new-tag {
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.goods-container .input-new-tag {
		width: 90px;
		margin-right: 10px;
		vertical-align: bottom;
	}

	.goods-container .el-tag {
		margin-right: 10px;
	}

	.goods-container .goods-content {
		margin-bottom: 10px;
		padding: 14px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		background-color: #fcfcfc;
	}

	.goods-content .goods-content-box {
		display: flex;
		align-items: center;
	}

	.goods-content-box .goods-content-left {
		flex: 1;
	}
</style>
